import Cookies from "js-cookie";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import * as config from "../../../config/config";
import { getCompanyLogoImage } from "../../../helpers/data_management";
import { sendTrackingEvent } from "../../../helpers/tracking_management";
import { runWithConnorsApplyConfirm } from "../../shared/ConnorsApplyConfirm/runWithConnorsApplyConfirm";
import {
  CompanyNameRow,
  CompanyVerifiedBadge,
} from "../../jobs/AccordionJobCard/styles";
import {
  CompanyDetailsContainer,
  CompanyImageBanner,
  CompanyIndustry,
  CompanyLogo,
  CompanyName,
  ImageContainer,
  JobCount,
  JobIconStyled,
  LinkWrapper,
  Wrapper,
} from "./styles";

export default function CompanyCard(props) {
  const { company } = props;
  const { t } = useTranslation();
  const industries = useSelector((state) => state.companies.industries);

  const [imageError, setImageError] = useState(false);

  const companyLogo = useMemo(() => {
    if (imageError) {
      return (
        config.assetDomain +
        "/images/backgrounds/hiredly-jobs-malaysia-wobb-background-v1.png"
      );
    }

    return getCompanyLogoImage(company);
  }, [company, imageError]);

  const companyImageBanner = "https:" + company?.coverImageThumb;

  const noImage = !company?.logo || imageError;

  const industryLabel = useMemo(() => {
    if (!company?.industry && !company?.industryId) return "";
    const industry = industries?.find(
      (item) => item.id === company?.industryId
    );
    const fallback = industry?.title || company?.industry || "";
    const keyBase = industry?.slug || fallback;
    if (!keyBase) return fallback;
    const key = keyBase
      .toString()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
    return t(`companies.industry_labels.${key}`, { defaultValue: fallback });
  }, [company?.industry, company?.industryId, industries, t]);

  function executeCardClick() {
    sendTrackingEvent({
      event: "CE_click-company-company-list",
      "company-id": company.id,
    });

    Cookies.set("click-source", "companies_page");
    window.open(`/companies/${company?.slug}`, "_blank");
  }

  function handleCardClick(e) {
    runWithConnorsApplyConfirm(company, executeCardClick, e);
  }

  const isCompanyVerified =
    company?.verified === true ||
    company?.name === "Hiredly" ||
    company?.name === "Hiredly X";

  return (
    <LinkWrapper href={`/companies/${company?.slug}`} target="_blank">
      <Wrapper onClick={handleCardClick}>
        <ImageContainer>
          <CompanyImageBanner
            src={companyImageBanner}
            alt={company?.name}
            loading={"lazy"}
          />
          <CompanyLogo
            src={companyLogo}
            alt={company?.name}
            loading={"lazy"}
            $placeholder={noImage}
            onError={() => setImageError(true)}
          />
        </ImageContainer>

        <CompanyDetailsContainer>
          <CompanyNameRow
            sx={{ maxWidth: "100%", minWidth: 0, overflow: "hidden" }}
          >
            <CompanyName>{company.name}</CompanyName>
            {isCompanyVerified && (
              <CompanyVerifiedBadge aria-label="Verified company" />
            )}
          </CompanyNameRow>
          <CompanyIndustry>{industryLabel}</CompanyIndustry>
          {company.jobCount > 0 && (
            <JobCount>
              <JobIconStyled />
              {company.jobCount} jobs
            </JobCount>
          )}
        </CompanyDetailsContainer>
      </Wrapper>
    </LinkWrapper>
  );
}
